import React, { useState, useEffect } from "react";
import Header from "../../components/header1/Header1";
import Footer from "../../components/footer/Footer";
import bannerImage from "../../elements/hero-banner-faqs-page.png";
import logo_img from "../../elements/Agivant-AMP-D-SE-Logo-Final 1.png";
import { SlCloudUpload } from "react-icons/sl";
import { IoIosAttach, IoIosCheckmarkCircleOutline } from "react-icons/io";
import { IoIosArrowDropdown } from "react-icons/io";
import CodingPlatform from "./CodingPlatform";

import {
  fetchStudentLearningTracks,
  markAsComplete,
} from "../../services/studentportalapis";
import { useParams } from "react-router-dom";
import Assessment from "./Assessment";
import DownloadCertificate from "./DownloadCerificate";
import { PiStudent } from "react-icons/pi";
// import { IoIosAttach } from "react-icons/io";
import { FaRegCheckCircle } from "react-icons/fa";
import { MdOutlineExpandCircleDown } from "react-icons/md";

const MyLearningTrack = () => {
  const [activeTab, setActiveTab] = useState("courses");
  const [openAccordion, setOpenAccordion] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [openDetails, setOpenDetails] = useState(null);
  const [courseDetails, setCourseDetails] = useState([]);
  const [file, setFile] = useState(null);
  const { courseName, id } = useParams();
  const [certificateUrl, setCertificateUrl] = useState("");
  const storetrackid = Number(id);
  const [learningTrackDescription, setLearningTrackDescription] = useState("");
  const [studentId] = useState(
    JSON.parse(localStorage.getItem("student-details"))["studentId"]
  );
  const [courseId, setSelectedCourseId] = useState(5);
  const [platformName, setPlatformName] = useState("");
  const [error, setError] = useState("");

  const handleShowPopup = (courseId, platformName) => {
    setSelectedCourseId(courseId);
    setPlatformName(platformName);
    setShowPopup(true);
  };

  useEffect(() => {
    console.log("RERENDERED");
    if (showPopup && courseId) {
      const studentId = JSON.parse(localStorage.getItem("student-details"))[
        "studentId"
      ];

      fetchStudentLearningTracks(studentId)
        .then((data) => {
          setCourseDetails(data);

          setLearningTrackDescription(
            data.learningTrack.learningTrackDescription
          );

          // Initialize platformName to be updated later
          //let platformName = null;

          // Loop through the sections and courseGroups to find the course with the selected courseId
          data.learningTrack.sections.forEach((section) => {
            // Loop through the courseGroups within the section
            section.courseGroups.forEach((courseGroup) => {
              // Loop through the courses within the courseGroup
              courseGroup.courses.forEach((course) => {
                // console.log("Course:", course); // Debugging course data
                if (course.courseId === courseId) {
                  console.log(courseId);
                  setPlatformName(course.platformName); // Set platformName for the selected course
                }
              });
            });
          });
          // Directly extract the platformName from the data
          // const platformName = data.learningTrack.sections[0]?.courseGroups[0]?.courses[0]?.platformName;
          console.log("platformName:", platformName); // For debugging

          if (platformName) {
            // Set the platformName directly without fetching
            setPlatformName(platformName);
          } else {
            setError("No valid platform name found");
          }
        })
        .catch((err) => {
          console.error("Error fetching student tracks:", err);
          setError("Error fetching student tracks");
        });
    }
  }, [courseId]);

  const [message, setMessage] = useState("");

  const handleUrlChange = (e) => {
    setCertificateUrl(e.target.value);
  };

  // Function to validate the URL format
  const validateUrl = (url) => {
    const regex = /^(ftp|http|https):\/\/[^ "]+$/; // Simple regex for URL validation
    return regex.test(url);
  };

  // Optional: Check if the URL is reachable
  const checkUrlReachable = async (url) => {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" },
      });
      return response.ok;
    } catch (error) {
      return false; // If the URL is unreachable
    }
  };

  // Function to handle form submission
 const handleSubmit = async (e) => {
  e.preventDefault();
  setMessage("");

  try {
    const isUrlRequired = !["YouTube", "Refactoring Guru","Google"].includes(platformName);

    if (isUrlRequired && !certificateUrl) {
      setMessage("Please enter a valid certificate URL.");
      return;
    }

    const response = await markAsComplete(
      studentId,
      courseId,
      isUrlRequired ? certificateUrl : undefined // send undefined if not required
    );

    if (response.success) {
      setShowPopup(false);
      window.location.reload();
    } else {
      setMessage(response.message);
    }
  } catch (error) {
    if (error.response?.status === 409) {
      setMessage(
        error.response.data.message || "This certificate URL is already submitted."
      );
    } else {
      setMessage(
        error.response?.data?.message || "Something went wrong. Please try again."
      );
    }
    console.error("Error:", error);
  }
};



  useEffect(() => {
    const studentId = JSON.parse(localStorage.getItem("student-details"))[
      "studentId"
    ];
    fetchStudentLearningTracks(studentId)
      .then((data) => {
        setCourseDetails(data);
        console.log("Data is:", data);
        console.log("track id :", data.learningTrack.trackId);
        console.log("id is:", id);

        setLearningTrackDescription(
          data.learningTrack.learningTrackDescription
        );
      })
      .catch((err) => console.error("Error fetching student tracks:", err));
  }, []);

  const toggleAccordion = (accordionId) => {
    setOpenAccordion(openAccordion === accordionId ? null : accordionId);
  };

  const handlePopupClose = () => {
    setMessage("");
    setShowPopup(false); // Close the popup
  };
  const handleToggleDetails = (index) => {
    setOpenDetails(openDetails === index ? null : index);
  };

  const renderedCourses = new Set();

  return (
    <div className="sm:mx-10 md:mx-20">
      <Header />
      <div className="relative w-full">
        <img
          src={bannerImage}
          alt="Banner"
          className="w-full sm:h-[300px] h-auto object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-start text-white font-medium p-4 sm:p-6">
          <div className="flex flex-col w-full sm:w-2/5 p-3">
            <p className="text-xl sm:text-xl md:text-xl leading-snug mb-1 text-left break-words lg:text-3xl xl:text-4xl">
              Choose your Track and Discover your path to AI Mastery and
              Certifications
            </p>
          </div>
        </div>
      </div>
      <div className="text-center py-4 mx-4">
        <div className="faq-content sm:px-4 w:[80%] lg:w-[75%] mx-auto">
          <div className="font-bold text-left text-blue-900 text-lg sm:px-4">
            To earn certification, a student must complete all three mandatory
            components:
            <ol className="list-decimal list-inside mt-2">
              <li>
                <strong>Courses</strong> – Completion of all assigned learning
                curriculum
              </li>
              <li>
                <strong>Coding Platform</strong> – Students are required to have
                solved at least 250 problems on any two platforms of their
                choice.
              </li>
              <li>
                <strong>Assessment</strong> – For your track, you are required
                to complete the certifications mentioned below:
                <ul className="list-disc list-inside ml-6 mt-2">
                  <li>Google Cloud Professional</li>
                  <li>AWS Cloud Professional</li>
                </ul>
              </li>
            </ol>
          </div>

          <div className="flex flex-col mt-4">
            <h1 className="text-3xl font-bold mt-4">My Learning Track</h1>
            <p className="text-2xl text-gray-500 mt-3 mb-8">{courseName}</p>
          </div>

          <div className="sm:px-6  mx-auto">
            <div className="relative h-2 bg-gray-200 rounded-lg">
              {/* Progress bar */}
              <div
                className="h-full bg-green-500 rounded-lg"
                style={{ width: courseDetails.completionPercentage + "%" }}
              ></div>

              {/* Top left icon */}
              <div className="absolute top-[-35px] left-[10px] text-xl">
                <PiStudent className="text-2xl" />
              </div>

              {/* Right icon */}
              <div className="absolute top-[-25px] right-[10px] transform -translate-y-1/2 text-xl">
                <img src={logo_img} className="w-12 h-10"></img>
              </div>

              {/* Bottom left text */}
              <div className="absolute bottom-[-20px] left-2 text-sm text-gray-500">
                Student
              </div>

              {/* Bottom right text */}
              <div className="absolute bottom-[-20px] right-2 text-sm text-gray-500">
                AI Amp'd Software Engineer
              </div>
            </div>
            <div className="flex flex-row sm:flex-row justify-center sm:justify-between sm:space-x-8 mt-2 pt-3">
              <button
                className={`w-full sm:w-auto px-3 sm:px-6 py-2 md:text-xl text-sm border-b-2 border-white bg-white font-bold ${
                  activeTab === "courses" ? "text-blue-700" : "text-gray-600"
                }`}
                onClick={() => setActiveTab("courses")}
              >
                Courses
              </button>
              <button
                className={`w-full sm:w-auto px-3 sm:px-6 py-2 md:text-xl text-sm border-white border-b-2 bg-white font-bold ${
                  activeTab === "platform" ? "text-blue-700" : "text-gray-600"
                }`}
                onClick={() => setActiveTab("platform")}
              >
                Coding Platform
              </button>
              <button
                className={`w-full sm:w-auto px-3 sm:px-6 py-2 md:text-xl text-sm border-b-2 border-white bg-white font-bold ${
                  activeTab === "assessment" ? "text-blue-700" : "text-gray-600"
                }`}
                onClick={() => setActiveTab("assessment")}
              >
                Assessment
              </button>

               <button
                className={`w-full sm:w-auto px-3 sm:px-6 py-2 md:text-xl text-sm border-b-2 border-white bg-white font-bold ${
                  activeTab === "Download Certificate" ? "text-blue-700" : "text-gray-600"
                }`}
                onClick={() => setActiveTab("Download Certificate")}
              >
                Download Certificate
              </button>
            </div>
            <div className="relative w-full">
              <hr className="absolute top-0 left-0 w-full border-gray-400 border-2" />
              {activeTab === "courses" && (
                <hr className="absolute top-0 left-0 w-1/4 border-blue-800 border-4" />
              )}
              {activeTab === "platform" && (
                <hr className="absolute top-0 left-1/4 w-1/4 border-blue-800 border-4" />
              )}
              {activeTab === "assessment" && (
                <hr className="absolute top-0 left-2/4 w-1/4 border-blue-800 border-4" />
              )}
              {activeTab === "Download Certificate" && (
                <hr className="absolute top-0 left-3/4 w-1/4 border-blue-800 border-4" />
              )}
            </div>
            <div className="mt-4">
              {activeTab === "courses" &&
                courseDetails &&
                courseDetails.learningTrack &&
                courseDetails.learningTrack.trackId === storetrackid && (
                  <div className="mb-4">
                    {courseDetails.learningTrack.sections.map(
                      (section, secIndex) => (
                        <div key={secIndex} className="mb-4">
                          <button
                            className="w-full flex items-center justify-between font-bold text-2xl px-4 py-2 bg-blue-900 rounded-md"
                            onClick={() => toggleAccordion(secIndex)}
                          >
                            {/* Button Text */}
                            <span className="text-left">
                              {section.sectionName}
                            </span>

                            {/* Progress Bar Section */}
                            <div className="flex flex-col items-end ml-4 w-1/3">
                              {/* Percentage and 'Completed' Labels */}
                              <div className="flex justify-between w-full mb-1">
                                <span className="text-xs font-bold text-green-500 px-1">
                                  {section.completionPercentage}%
                                </span>
                                <span className="text-xs text-gray-300">
                                  Completed
                                </span>
                              </div>
                              {/* Progress Bar */}
                              <div className="w-full bg-white rounded-full h-2">
                                <div
                                  className="bg-green-500 h-2 rounded-full"
                                  style={{
                                    width: section.completionPercentage + "%",
                                  }}
                                ></div>
                              </div>
                            </div>
                          </button>

                          {openAccordion === secIndex && (
                            <div className="items-left">
                              {section.courseGroups.map((group, groupIndex) => (
                                <div key={groupIndex} className="mb-4 py-2">
                                  {/* <div>
                                    <p className="text-left text-blue-900 text-sm mb-2 pt-2">
                                      {group.groupName}
                                    </p>
                                    <p className="text-left font-normal text-gray-700 text-sm mb-4 leading-4">
                                      {group.groupDescription}
                                    </p>
                                  </div> */}
                                  <ul className="flex flex-col mt-2">
                                    {group.courses.map((course, k) => {
                                      if (!renderedCourses.has(course.poolId)) {
                                        renderedCourses.add(course.poolId);

                                        const groupedCourses =
                                          group.courses.filter(
                                            (c) => c.poolId === course.poolId
                                          );
                                        // const hasBorder =
                                        //   groupedCourses.length > 1
                                        //     ? "bg-gray-100 border-2 rounded-lg border-gray-500 px-3"
                                        //     : "border-b-2 px-4";

                                        return (
                                          <div
                                            key={k}
                                            className={`bg-gray-100 border-2 rounded-lg border-gray-500 px-3 mb-4`}
                                          >
                                            {groupedCourses.length > 1 && (
                                              <div className="flex justify-between">
                                                <p className="text-left text-sky-500  p-0 mt-2 mb-0 inline-block text-sm">
                                                  Choose any one
                                                </p>
                                                {/* <p className="text-right bg-gray-200 border-1 border-gray-900 text-gray-900 text-xs font-semibold rounded-md px-4 py-1 mt-2 mb-0 inline-block">
                                                  Level - {group.levelName}
                                                </p> */}
                                              </div>
                                            )}
                                            {groupedCourses.map(
                                              (groupedCourse, idx) => (
                                                <li
                                                  key={idx}
                                                  className="w-full flex flex-col justify-between text-left font-semibold text-gray-700 text-sm py-3 border-b-2 border-gray-300 last:border-b-0"
                                                >
                                                  <div className="w-full flex flex-col justify-between">
                                                    <div className=" grid grid-cols-2 text-left space-x-3">
                                                      <div className="">
                                                        <p className="flex mb-0 px-2 text-left">
                                                          {
                                                            groupedCourse.courseName
                                                          }
                                                        </p>
                                                        <span className="text-gray-700 text-xs px-2">
                                                          {
                                                            groupedCourse.numberOfModules
                                                          }{" "}
                                                          modules ·{" "}
                                                          {
                                                            groupedCourse.durationInHours
                                                          }{" "}
                                                          hours ·{" "}
                                                          {
                                                            groupedCourse.platformName
                                                          }{" "}
                                                          ·{" "}
                                                          {groupedCourse.paid
                                                            ? "Paid"
                                                            : "Free"}
                                                        </span>
                                                      </div>

                                                      <div className="">
                                                        <div className="  grid md:grid-cols-3 sm:grid-row-3  items-baseline gap-x-1 text-left">
                                                          <button className="bg-transparent text-blue-900 text-xs hover:cursor-pointer text-left py-2">
                                                            <a
                                                              href={
                                                                groupedCourse.courseLink
                                                              }
                                                              target="_blank"
                                                              rel="noopener noreferrer"
                                                              className=""
                                                            >
                                                              {
                                                                groupedCourse.platformName
                                                              }
                                                            </a>
                                                          </button>
                                                          <div>
                                                            {groupedCourse.completed ? (
                                                              <button className="flex flex-row text-green-500 bg-transparent text-xs  hover:cursor-pointer justify-start text-left py-2 w-full">
                                                                Completed
                                                                <FaRegCheckCircle className="ml-1 text-green-500 text-lg" />
                                                              </button>
                                                            ) : (
                                                              <button
                                                                onClick={() =>
                                                                  handleShowPopup(
                                                                    groupedCourse.courseId,
                                                                    groupedCourse.platformName
                                                                  )
                                                                }
                                                                className="flex flex-row text-blue-900 bg-transparent text-xs font-normal hover:cursor-pointer justify-start text-left  py-2 w-full"
                                                              >
                                                                Mark as Complete
                                                                <IoIosAttach className="ml-1 text-lg font-extralight" />
                                                              </button>
                                                            )}
                                                          </div>

                                                          <div >
                                                            <button
                                                              onClick={() =>
                                                                handleToggleDetails(
                                                                  groupedCourse.courseId
                                                                )
                                                              }
                                                              className="flex flex-row text-gray-900 bg-transparent text-xs font-normal hover:underline cursor-pointer justify-start text-left py-2 w-full"
                                                            >
                                                              Details
                                                              <MdOutlineExpandCircleDown className="ml-1 text-lg" />
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div>
                                                    {openDetails ===
                                                      groupedCourse.courseId && (
                                                      <div className="text-gray-700 mt-2 p-2 bg-gray-200">
                                                        <div className="font-semibold">
                                                          Key takeaways
                                                        </div>
                                                        <ul className="list-disc list-inside text-left text-xs mt-1 font-normal leading-4 tracking-wide ">
                                                          {groupedCourse.courseDetails
                                                            .split(".")
                                                            .filter(
                                                              (detail) =>
                                                                detail.trim() !==
                                                                ""
                                                            )
                                                            .map(
                                                              (
                                                                detail,
                                                                index
                                                              ) => (
                                                                <li
                                                                  className="py-1 text-md text-gray-500"
                                                                  key={index}
                                                                >
                                                                  {detail.trim()}
                                                                </li>
                                                              )
                                                            )}
                                                        </ul>
                                                      </div>
                                                    )}
                                                  </div>
                                                </li>
                                              )
                                            )}
                                          </div>
                                        );
                                      }
                                    })}
                                  </ul>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )
                    )}
                  </div>
                )}

              {activeTab === "platform" && <CodingPlatform />}
              {activeTab === "assessment" && <Assessment />}
              {activeTab === "Download Certificate" && <DownloadCertificate completionPercentage={courseDetails.completionPercentage} />}
            </div>

            {showPopup && (
  <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
    <div className="bg-white pb-6 px-6 pt-3 rounded-md shadow-lg mx-auto relative w-full max-w-2xl">
      <button
        onClick={handlePopupClose}
        className="absolute top-2 bg-white right-4 text-gray-500 text-2xl"
      >
        &times;
      </button>

      <h2 className="text-lg text-left font-bold mt-0 mb-2">
        Add Certification
      </h2>

      <div className="flex flex-col items-center justify-center rounded-lg border-dotted border-2 border-blue-800 p-6 mb-2 text-center">
        <p className="text-gray-700 font-semibold text-base mb-3">
          Certification Platform
        </p>

        <div className="w-full mb-4 p-2 border-2 border-gray-300 rounded-md bg-gray-100 text-gray-700">
          {platformName || "Loading..."}
        </div>

        {["YouTube", "Refactoring Guru","Google"].includes(platformName) ? (
          <>
            <p className="text-gray-700 font-semibold text-base mb-3">
              No certification URL required for this platform.
            </p>
            <button
              onClick={handleSubmit}
              className="mt-4 px-6 py-2 bg-green-500 text-white font-semibold rounded-lg hover:bg-green-600"
            >
              Mark as Complete
            </button>
          </>
        ) : (
          <>
            <p className="text-gray-700 font-semibold text-base mb-3">
              Enter Certification URL
            </p>

            <input
              type="url"
              placeholder="Enter the URL"
              className="w-full mb-4 p-2 border-2 border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500"
              onChange={handleUrlChange}
            />

            <small className="text-gray-400 font-semibold text-base my-2">
              URLs should be active and publicly accessible
            </small>

            {message && <p className="text-red-500 mt-2">{message}</p>}

            <button
              onClick={handleSubmit}
              className="mt-4 px-6 py-2 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600"
            >
              Submit
            </button>
          </>
        )}
      </div>
    </div>
  </div>
)}

          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MyLearningTrack;
